module.exports = __webpack_public_path__ + "img/promo-bg--579.f7105df.webp";